/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { toAbsoluteUrl } from '../../../../../../../_metronic/helpers'
import { SearchInput } from '../../../../../components/SearchInput'
import useSize from '../../../../../../hooks/useSize'

type Props = {
  className: string
  plants: any[]
  formik: any
}

const ListPlantsLinked: React.FC<Props> = ({ className, plants, formik }) => {
  const [control, setControl] = useState(false)
  const [mySearch, setMySearch] = useState<any[]>([])
  const { width } = useSize()
  const selectAllRef = useRef<HTMLInputElement | null>(null)

  const visiblePlants = control ? mySearch : (plants || [])
  const selectedIds: string[] = formik.values.idsPlants || []
  const visibleIds = visiblePlants.map((plant: any) => plant.id)
  const allVisibleSelected =
    visibleIds.length > 0 && visibleIds.every((id: string) => selectedIds.includes(id))
  const someVisibleSelected = visibleIds.some((id: string) => selectedIds.includes(id))

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = someVisibleSelected && !allVisibleSelected
    }
  }, [someVisibleSelected, allVisibleSelected])

  const updateData = (value: string, checked: boolean) => {
    let valuesFormik = formik.values.idsPlants || []
    if (checked === true) {
      valuesFormik = [...valuesFormik, value]
    } else {
      valuesFormik = valuesFormik.filter((id: string) => id !== value)
    }
    formik.setFieldValue('idsPlants', valuesFormik)
  }

  const toggleSelectAll = (checked: boolean) => {
    if (checked) {
      formik.setFieldValue('idsPlants', Array.from(new Set([...selectedIds, ...visibleIds])))
      return
    }

    formik.setFieldValue(
      'idsPlants',
      selectedIds.filter((id: string) => !visibleIds.includes(id))
    )
  }

  const renderPlant = (plant: any) => (
    <div
      key={plant.id}
      className='d-flex align-items-center mb-7'
      style={{ justifyContent: 'space-between' }}
    >
      <div className='d-flex align-items-center'>
        <div className='symbol symbol-50px me-5'>
          <span
            className='symbol-label'
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <div
              className='symbol symbol-50px'
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <img src={toAbsoluteUrl('/media/imgs/plant2.png')} className='' alt='' />
            </div>
          </span>
        </div>
        <div className='d-flex flex-column'>
          <a href='#' className='text-dark text-hover-primary fs-6 fw-bold'>
            {plant.name}
          </a>
          <span className='text-muted fw-semibold'>
            {plant.address ? plant.address : 'Não localizado.'}
          </span>
        </div>
      </div>
      <div className='form-check form-check-custom form-check-success form-check-solid mx-5'>
        <input
          className={`form-check-input ${(formik.values.idsPlants || []).some(
            (id: string) => id === plant.id
          )
            ? 'bg-primary'
            : 'bg-secondary'
            }`}
          type='checkbox'
          checked={(formik.values.idsPlants || []).some((id: string) => id === plant.id)}
          value={plant.id}
          onChange={(e) => {
            updateData(e.target.value, e.target.checked)
          }}
        />
      </div>
    </div>
  )

  return (
    <div className={`card ${className}`} style={{ paddingBottom: '1rem' }}>
      <div className='card-header border-0 pt-5' style={{ display: 'flex', alignItems: 'center' }}>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>Lista de usinas</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>Vincular usinas à tag</span>
        </h3>

        <div>
          <SearchInput
            className={`form-control form-control-solid bg-body ps-14 ${width < 1200 ? 'fs-7' : ''}`}
            placeholder='Buscar'
            myDate={plants}
            setMySearch={setMySearch}
            control={control}
            style={{ flex: '1', height: '3rem' }}
            setControl={setControl}
            searchParameter='name'
          />
        </div>
      </div>

      <div className='card-body pt-5' style={{ height: '20rem', overflowY: 'auto' }}>
        {plants && plants.length > 0 ? (
          <>
            <div
              className='d-flex align-items-center mb-5 pb-3'
              style={{ justifyContent: 'space-between', borderBottom: '1px dashed #e4e6ef' }}
            >
              <span className='text-muted fw-semibold fs-8'>
                {control
                  ? `${visibleIds.length} na busca`
                  : `${visibleIds.length} usinas`}
              </span>
              <label className='d-flex align-items-center cursor-pointer mb-0'>
                <span className='fw-bold text-dark fs-7 me-3'>Selecionar todas</span>
                <div className='form-check form-check-custom form-check-success form-check-solid'>
                  <input
                    ref={selectAllRef}
                    className={`form-check-input ${allVisibleSelected ? 'bg-primary' : 'bg-secondary'}`}
                    type='checkbox'
                    disabled={visibleIds.length === 0}
                    checked={allVisibleSelected}
                    onChange={(e) => toggleSelectAll(e.target.checked)}
                  />
                </div>
              </label>
            </div>
            {control ? mySearch.map(renderPlant) : plants.map(renderPlant)}
          </>
        ) : (
          <div
            className='d-flex align-items-center mb-7'
            style={{ height: '100%', justifyContent: 'center' }}
          >
            <h3 className='card-title align-items-start flex-column'>
              <span className='text-muted mt-1 fw-semibold fs-7'>Não há usinas vinculadas.</span>
            </h3>
          </div>
        )}
      </div>
    </div>
  )
}

export { ListPlantsLinked }
